import { createContext, useContext } from 'react';

/**
 * @typedef {{
 *   workSites: any[],
 *   workSiteId: string,
 *   setWorkSiteId: (id: string) => void,
 *   bumpDashboardStats: () => void,
 *   toast: (variant: string, msg: string) => void,
 *   statsReloadNonce: number,
 *   openNewConsultation: () => void,
 *   openNewPrescription: () => void,
 *   canPrescribe: boolean,
 *   portalPaths: Record<string, string>,
 *   clinicalWorkspace: 'physician' | 'headDoctor' | 'dentist' | 'nurse'
 * }} DoctorWorkspaceShape
 */

export const DoctorWorkspaceContext = createContext(/** @type {DoctorWorkspaceShape | null} */ (null));

export function useDoctorWorkspace() {
  const v = useContext(DoctorWorkspaceContext);
  if (!v) throw new Error('useDoctorWorkspace doit être utilisé dans DoctorLayout.');
  return v;
}
